(function ($) {
	'use strict';

	$(function () {
		function resetKeyEvents($offcanvasLinks) {
			$offcanvasLinks.off('keydown');
		}

		function setKeyEvents($offcanvasLinks) {
			$offcanvasLinks.last().on('keydown', (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					$offcanvas.removeClass(activeClass);
					$body.removeClass("overflow-hidden");
					$trigger.first().focus();
				}
			});

			$offcanvasLinks.first().on('keydown', (e) => {
				if (e.key === 'Tab' && e.shiftKey) {
					$offcanvas.removeClass(activeClass);
					$body.removeClass("overflow-hidden");
					$trigger.first().focus();
				}
			});
		}

		const activeClass = 'site-offcanvas--is-active';
		const bodyActiveClass = 'offcanvas-is-active';

		const $trigger = $('.js-site-offcanvas-trigger');
		const $offcanvas = $('.js-site-offcanvas');
		const $subMenuTriggers = $('.js-offcanvas-menu-trigger');
		const $body = $('body');

		let $offcanvasLinks = $('.offcanvas-menu__link:visible,.site-offcanvas__btn');

		const getOffcanvasLinks = debounce(function () {
			$offcanvasLinks = $('.offcanvas-menu__link:visible,.site-offcanvas__btn');
			resetKeyEvents($offcanvasLinks);
			setKeyEvents($offcanvasLinks);
		}, 250);

		window.addEventListener('resize', getOffcanvasLinks);

		$trigger.on('click', function () {
			$offcanvas.toggleClass(activeClass);
			$body.toggleClass(bodyActiveClass);
		});

		$trigger.on('keydown', (e) => {
			if (e.key === 'Enter' || e.code === 'Space') {
				setTimeout(function () {
					$offcanvasLinks.first().focus();
				}, 100);
			}
		});

		$subMenuTriggers.on('keydown', function (e) {
			if (e.key === 'Enter' || e.code === 'Space') {
				$firstChildLink = $(this).parent().find('.offcanvas-menu-submenu li').first().find('a').first();

				setTimeout(function () {
					$firstChildLink.focus();
				}, 100);
			}
		});

		setKeyEvents($offcanvasLinks);
	});
})(jQuery);
